import { createCard } from "./card.js";
import { SUITS, RANKS } from "./constants.js";

export function buildStandardDeck() {
  const deck = [];
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      deck.push(createCard(suit, rank));
    }
  }
  return deck;
}

export function shuffleCards(cards, rng = Math.random) {
  const shuffled = [...cards];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1));
    const temp = shuffled[i];
    shuffled[i] = shuffled[j];
    shuffled[j] = temp;
  }
  return shuffled;
}

export function createDeck({ predefinedCards, shuffle = true, rng = Math.random } = {}) {
  if (predefinedCards && predefinedCards.length > 0) {
    return predefinedCards.map((card, index) => createCard(card.suit, card.rank, card.id ?? `preset-${index}`));
  }

  const baseDeck = buildStandardDeck();
  return shuffle ? shuffleCards(baseDeck, rng) : baseDeck;
}

export function drawCardFromDeck(deck) {
  if (deck.length === 0) {
    return null;
  }
  return deck.shift();
}
